module.exports = __webpack_public_path__ + "img/组 2141@2x.4783a8c8.png";